export default "__VITE_PUBLIC_ASSET__456160ce__"